import { render } from "./KidHeader.vue?vue&type=template&id=e7229994&scoped=true"
import script from "./KidHeader.vue?vue&type=script&lang=js"
export * from "./KidHeader.vue?vue&type=script&lang=js"

import "./KidHeader.vue?vue&type=style&index=0&id=e7229994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7229994"]])

export default __exports__